<template>
  <v-container fluid>
    <v-row class="mb-n6">
      <v-col>
        <p>ລາຍງານເຄື່ອນໄຫວລູກຄ້າທຸລະກິດ</p>
      </v-col>
    </v-row>

    <v-card class="mt-6">
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <v-menu
              v-model="fromMenu"
              :close-on-content-click="true"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFrom"
                  label="ອະນຸມັດແຕ່ວັນທີ"
                  readonly
                  outlined
                  dense
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="dateFrom" />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-menu
              v-model="toMenu"
              :close-on-content-click="true"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateTo"
                  label="ຫາວັນທີ"
                  readonly
                  outlined
                  dense
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dateTo"
                :min="dateFrom || undefined"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-select
              v-model="kind"
              :items="kinds"
              label="ປະເພດ"
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col
            cols="6"
            md="2"
          >
            <v-btn
              color="primary"
              block
              @click="fetchData()"
            >
              <v-icon left>
                mdi-magnify
              </v-icon>
              ຄົ້ນຫາ
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            md="2"
          >
            <v-btn
              color="success"
              block
              :loading="exporting"
              :disabled="exporting || !rows.length"
              @click="exportExcel()"
            >
              <v-icon left>
                mdi-microsoft-excel
              </v-icon>
              Export Excel
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle class="pt-2">
        ທັງໝົດ {{ rows.length }} ລາຍການ
        <span class="ml-4">ເປີດໃໝ່ {{ count('new') }}</span>
        <span class="ml-4">ປິດສາຍບ້ານເປີດທຸລະກິດ {{ count('convert') }}</span>
        <span class="ml-4">ແກ້ໄຂ {{ count('edit') }}</span>
      </v-card-subtitle>
      <v-data-table
        :headers="headers"
        :items="rows"
        item-key="key"
        :items-per-page="50"
        dense
        class="activity-table"
      >
        <template v-slot:[`item.kind`]="{ item }">
          <v-chip
            x-small
            label
            :color="kindColor(item.kind)"
            dark
          >
            {{ kindName(item.kind) }}
          </v-chip>
        </template>
        <template v-slot:[`item.old_value`]="{ item }">
          {{ money(item.old_value) }}
        </template>
        <template v-slot:[`item.new_value`]="{ item }">
          {{ money(item.new_value) }}
        </template>
        <template v-slot:[`item.location`]="{ item }">
          <a
            v-if="item.location"
            :href="item.location"
            target="_blank"
          >ແຜນທີ່</a>
        </template>
        <template v-slot:[`item.conditions`]="{ item }">
          <div style="min-width: 200px; white-space: pre-line">
            {{ item.conditions }}
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div style="min-width: 220px">
            {{ item.status }}
          </div>
        </template>
        <template v-slot:[`item.billing_status`]="{ item }">
          <v-chip
            v-if="item.billing_status"
            x-small
            :color="item.billing_status === 'active' ? 'green lighten-5' : 'red lighten-5'"
            :text-color="item.billing_status === 'active' ? 'green darken-2' : 'red darken-2'"
          >
            {{ item.billing_status }}
          </v-chip>
        </template>
        <template v-slot:[`item.collect_status`]="{ item }">
          <v-chip
            v-if="item.collect_status"
            x-small
            :color="item.collect_status === 'ເກັບໄດ້' ? 'green lighten-5' : 'red lighten-5'"
            :text-color="item.collect_status === 'ເກັບໄດ້' ? 'green darken-2' : 'red darken-2'"
          >
            {{ item.collect_status }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { today } from '@/Helpers/localDate';

const KIND_NAMES = { new: 'ເປີດໃໝ່', convert: 'ປິດສາຍບ້ານ', edit: 'ແກ້ໄຂ' };
const KIND_COLORS = { new: 'success', convert: 'indigo', edit: 'orange' };

export default {
  title() {
    return 'Vientiane Waste Co-Dev|Company Activity Report';
  },
  data() {
    return {
      rows: [],
      // Opens on today; widen the dates for a month or more.
      dateFrom: today(),
      dateTo: today(),
      fromMenu: false,
      toMenu: false,
      kind: 'all',
      exporting: false,
      kinds: [
        // Vuetify does not show a selected null value, so "all" is a real value.
        { text: 'ທັງໝົດ', value: 'all' },
        { text: 'ເປີດຖານສັນຍາໃໝ່', value: 'new' },
        { text: 'ປິດສາຍບ້ານເປີດທຸລະກິດ', value: 'convert' },
        { text: 'ແກ້ໄຂຂໍ້ມູນ', value: 'edit' },
      ],
      // Same columns as the business team's sheet (ການເຄືອນໄຫວລູກຄ້າທຸລະກິດ.xlsx).
      headers: [
        { text: 'ລຳດັບ', value: 'no' },
        { text: 'ປະເພດ', value: 'kind' },
        { text: 'ຊື່ບໍລິສັດ', value: 'company_name' },
        { text: 'ເບີໂທ', value: 'phone' },
        { text: 'ຜູ້ປະສານງານຂໍເພີ່ມຂໍ້ມູນເຂົ້າໃນລະບົບ', value: 'requester_name' },
        { text: 'ພາກສ່ວນຜູ້ປະສານງານເພີ່ມຂໍ້ມູນເຂົ້າໃນລະບົບ', value: 'requester_department' },
        { text: 'ເບີຜູ້ປະສານງານ', value: 'coordinator_phone' },
        { text: 'ບ້ານ', value: 'village' },
        { text: 'ເມືອງ', value: 'district' },
        { text: 'ເຮືອນເລກທີ', value: 'house_number' },
        { text: 'ໜ່ວຍ', value: 'unit' },
        { text: 'ປະເພດບໍລິການ', value: 'service_type' },
        { text: 'ຂີ້ເຫຍື້ອຄາດໝາຍ/ອາທິດ', value: 'bags_per_week' },
        { text: 'ຂີ້ເຫຍື້ອຄາດໝາຍ/ເດືອນ', value: 'bags_per_month' },
        { text: 'ມູນຄ່າສັນຍາເກົ່າ', value: 'old_value', align: 'end' },
        { text: 'ມູນຄ່າສັນຍາໃໝ່', value: 'new_value', align: 'end' },
        { text: 'ເງື່ອນໄຂ', value: 'conditions', sortable: false },
        { text: 'ມື້ບໍລິການ', value: 'service_days' },
        { text: 'ຕຳແໜ່ງທີ່ຢູ່(Link)', value: 'location', sortable: false },
        { text: 'ສະຖານະ', value: 'status', sortable: false },
        { text: 'ເລີ່ມວັນທີ', value: 'date' },
        { text: 'ID ເກົ່າ', value: 'old_id' },
        { text: 'ID ໃໝ່', value: 'new_id' },
        { text: 'ສະຖານະອອກບິນ', value: 'billing_status' },
        { text: 'ສະຖານະເກັບ', value: 'collect_status' },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    params() {
      return { date_from: this.dateFrom, date_to: this.dateTo, kind: this.kind === 'all' ? undefined : this.kind };
    },
    fetchData() {
      this.$store.commit('Loading_State', true);
      this.$axios
        .get('report-company-activity', { params: this.params() })
        .then((res) => {
          this.rows = res.data.data.data.map((row) => ({ ...row, key: `${row.kind}-${row.source_id}` }));
        })
        .catch((error) => this.toastError(error))
        .finally(() => {
          this.$store.commit('Loading_State', false);
        });
    },
    exportExcel() {
      this.exporting = true;
      this.$axios
        .get('report-company-activity/export', { params: this.params(), responseType: 'blob' })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = `ລາຍງານເຄື່ອນໄຫວລູກຄ້າທຸລະກິດ_${this.dateFrom}_${this.dateTo}.xlsx`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => this.toastError(error))
        .finally(() => {
          this.exporting = false;
        });
    },
    count(kind) {
      return this.rows.filter((row) => row.kind === kind).length;
    },
    kindName(kind) {
      return KIND_NAMES[kind] || kind;
    },
    kindColor(kind) {
      return KIND_COLORS[kind] || 'grey';
    },
    money(value) {
      return value === null || value === undefined ? '' : Number(value).toLocaleString();
    },
    toastError(error) {
      const data = (error.response && error.response.data) || {};
      this.$store.commit('Toast_State', { value: true, color: 'error', msg: data.message || 'Something went wrong' });
    },
  },
};
</script>

<style scoped>
.activity-table >>> th,
.activity-table >>> td {
  white-space: nowrap;
}
</style>
